import { render, staticRenderFns } from "./QuestionTabButtons.vue?vue&type=template&id=72e37e6e&scoped=true&"
import script from "./QuestionTabButtons.vue?vue&type=script&lang=js&"
export * from "./QuestionTabButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e37e6e",
  null
  
)

export default component.exports